const caseHistoryExportStatus = {
  PENDING: 0,
  AVAILABLE: 1,
  EXPIRED: 2,
}

export default caseHistoryExportStatus;